module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.8756a81c.svg";